import React from "react";

interface Props {
  label?: string;
  /** Array of all checkbox options */
  options: { id: string; label: string }[];
  /** Array of currently selected options */
  selectedOptions: string[];
  /** Function to call when toggling a checkbox */
  onSelect: (option: string) => void;
  labelClassName?: string;
  gridNumber?: number;
  className?: string;
}

/**
 * Renders a grid of checkboxes.
 */
export const IdCheckboxGrid: React.FC<Props> = ({
  label,
  options,
  selectedOptions,
  onSelect,
  labelClassName,
  gridNumber = 3,
  className,
}) => {
  return (
    <div className={className}>
      {label ? (
        <p
          className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
        >
          {label}
        </p>
      ) : null}
      <div className={`grid grid-cols-${gridNumber} gap-2`}>
        {options.map((option) => (
          <label key={option?.id} className="flex items-center space-x-2">
            <input
              type="checkbox"
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              checked={selectedOptions.includes(option?.id)}
              onChange={() => onSelect(option?.id)}
            />
            <span className="text-gray-700 text-sm">{option?.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
